import React, { Fragment, useState, useRef, useEffect } from "react";
import PromoCodeWrapper from "./promoCode.style";
import { InputSwitch } from "primereact/inputswitch";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";

import { withTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setLoading } from "../../../../redux/actions/travel";
import * as travelService from "../../../../services/travel-service";
import * as globalUtil from "../../../../helpers/utils";
import { useSelector } from "react-redux";
import { classNames } from "primereact/utils";
import OtpPage from "../OtpScreenEmail/otpPage";

const PromoCode = (props) => {
  const [promoCodeChecked, setPromoCodeChecked] = useState(false);
  const [promoCode, setPromoCode] = useState("");
  const dispatch = useDispatch();
  const toast = useRef(null);
  const [isValidPromo, setIsValidPromo] = useState(false);
  const travelDetails = useSelector((state) => state.travel.travelDetails);
  const [showOtpForm, setShowOtpForm] = useState(false);
  const { businessLine } = useSelector((state) => state.travel);

  const handleClick = () => {
    if (!promoCode) {
      return;
    }
    const regex = /^[a-zA-Z0-9]+([._]?[a-zA-Z0-9]+)*@sabic\.com$/;

    if (regex.test(promoCode)) {
      console.log("Valid email!");
      validatePromoEmail();
    } else {
      console.log("Invalid email!");
      validatePromoCode();
    }
  };
  const validatePromoEmail = () => {
    dispatch(setLoading(true));
    travelService
      .sendEmail({
        emailID: "rsharma@tawuniya.com", //promoCode
        channel: "Portal",
        languageCode: "E",
        LOB: "TR",
      })
      .then((response) => {
        dispatch(setLoading(false));
        if (response.data.statusDescritpion == "Success") {
          dispatch(setLoading(false));
          setShowOtpForm(true);
          // setIsValidPromo(true);
          // props.onValidPromo("SABIC2");
        } else {
          toast.current.show({
            severity: "error",
            detail: response.data.resultMessage,
          });
          setPromoCode("");
        }
      })
      .finally((e) => {
        // dispatch(setLoading(false))
        // setShowOtpForm(true)
      });
  };

  const showHidePromoSection = (e) => {
    const checked = e.value;
    if (!checked) {
      props.onValidPromo("");
      setPromoCode("");
    }
    setPromoCode("");
    setIsValidPromo(false)
    setPromoCodeChecked(checked);
    props.setPromoCodeFlag(checked);
  };

  useEffect(()=>{
    setIsValidPromo(false);
  },[promoCode])

  const validatePromoCode = () => {
    dispatch(setLoading(true));
    travelService
      .validatePromoCode(
        {
          promoCode: promoCode,
          langCode: globalUtil.getOneLetterLanguageCode(props.i18n.language),
          IDNumber: travelDetails.nationalId,
        },
        businessLine
      )
      .then((response) => {
        dispatch(setLoading(false));
        if (response.data.status == "Success") {
          setIsValidPromo(true);
          props.onValidPromo(promoCode);
        } else {
          props.onValidPromo(promoCode);
          toast.current.show({
            severity: "error",
            detail: response.data.resultMessage,
          });
          setPromoCode("");
        }
      })
      .finally((e) => {
        dispatch(setLoading(false));
      });
  };

  const verifyClicked = (otp) => {
    console.log("all done", otp);

    travelService
      .verifyEmailOTP({
        emailId: "rsharma@tawuniya.com", //promoCode
        channel: "Portal",
        languageCode: "E",
        otpCode: otp,
      })
      .then((response) => {
        dispatch(setLoading(false));
        if (response.data.statusDescritpion == "Success") {
          //finally logic

          setIsValidPromo(true);
          travelService
            .validatePromoCode(
              {
                promoCode: "SABIC2",
                langCode: globalUtil.getOneLetterLanguageCode(
                  props.i18n.language
                ),
                IDNumber: travelDetails.nationalId,
              },
              businessLine
            )
            .then((response) => {
              dispatch(setLoading(false));
              if (response.data.status == "Success") {
                setIsValidPromo(true);
                props.onValidPromo("SABIC2");
                setShowOtpForm(false);
              } else {
                toast.current.show({
                  severity: "error",
                  detail: response.data.resultMessage,
                });
                setPromoCode("");
              }
            })
            .finally((e) => {
              dispatch(setLoading(false));
            });

          //finally logic ends
        } else {
          toast.current.show({
            severity: "error",
            detail: response.data.statusDescritpion,
          });
          // setPromoCode("");
        }
      })
      .finally((e) => {
        // dispatch(setLoading(false))
        // setShowOtpForm(true)
        // setIsValidPromo(true);
        // travelService.validatePromoCode({
        //     "promoCode":"SABIC2",
        //     "langCode":globalUtil.getOneLetterLanguageCode(props.i18n.language),
        //     "IDNumber": travelDetails.nationalId
        //   }
        // ).then((response) => {
        //     dispatch(setLoading(false));
        //     if(response.data.status == "Success"){
        //         setIsValidPromo(true);
        //         props.onValidPromo("SABIC2");
        //         setShowOtpForm(false)
        //     }else {
        //         toast.current.show({severity:'error', detail:response.data.resultMessage});
        //         setPromoCode("");
        //     }
        // }).finally( e=>{dispatch(setLoading(false));})
      });
  };

  return (
    <PromoCodeWrapper>
      <Toast ref={toast} />
      <OtpPage
        show={showOtpForm}
        mobileNumber={promoCode}
        //   onSuccessVerify={onSuccessVerifyOTP}
        cancelOTP={() => setShowOtpForm(false)}
        verifyClicked={verifyClicked}
      />

      <div>
        <div className="d-flex">
          <InputSwitch
            className="mx-2"
            checked={promoCodeChecked}
            onChange={showHidePromoSection}
          />
          <div className="switch-text">{props.t("have-promo-code")}</div>
        </div>
        {promoCodeChecked && (
          <Fragment>
            <div
              className={
                "input-style " +
                (props.i18n.language === "ar" ? "ar" : "") +
                (businessLine ? " input-style-stc" : "")
              }
            >
              <div className="row justify-content-center justify-content-sm-start">
                <div className="col-md-6 col-10 position-relative mb-3">
                  <InputText
                    className={`w-100  ${classNames({
                      lato: promoCode,
                      textColor: promoCode,
                    })}`}
                    placeholder={props.t("promo-code")}
                    value={promoCode}
                    onChange={(e) => setPromoCode(e.target.value)}
                  />
                  {/* {promoCode !== null && <p className='round-style' onClick={removeData}><span>x</span></p>} */}
                </div>
                <div className="col-md-3 ms-4 ms-md-2">
                  <Button
                    disabled={!promoCode}
                    label={props.t("apply")}
                    // className="p-button-warning"
                    className={
                      "p-button-warning" +
                      (businessLine ? " p-button-warning-stc" : "")
                    }
                    onClick={handleClick}
                  />
                </div>
              </div>
            </div>
            <div className="text-content">
              {/* {promoCode && isValidPromo && (
                <p>
                  {props.t("promo-code")} {props.t("applied-successfuly")}.
                </p>
              )} */}
            </div>
          </Fragment>
        )}
      </div>
    </PromoCodeWrapper>
  );
};

export default withTranslation()(PromoCode);
